import styled from "styled-components";
import { theme } from "../../styles/theme";

import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    .introjs-tooltip {
        width: 100% !important;
        padding: 1rem !important;
        max-width: 19rem !important;

        border-radius: 0.75rem !important;
        background-color: ${theme.colors.gray.Cinza_2}!important;
        
        font-size: ${theme.typography.fontSize.bodyP} !important;
        color: ${theme.colors.white.Branco} !important;
    }

    .introjs-tooltiptext{
        padding: 0 !important;
        padding-bottom: 1rem !important;

        gap: 0.25rem;
        flex-direction: column;
        display: flex !important;

        >div {
            gap: 4px;
            display: flex;
            flex-direction: column;

            >h6{
                color: ${theme.colors.white.Branco};
                font-weight: ${theme.typography.fontWeight.extraBold};
                text-align: left;
                font-size: ${theme.typography.fontSize.h6};
                font-family: ${theme.typography.fontFamily.primary};
                line-height: ${theme.typography.lineHeight.h6};
            }

            >p{
                color: ${theme.colors.gray.Cinza_11};
                font-weight: ${theme.typography.fontWeight.regular};
                text-align: left;
                font-size: ${theme.typography.fontSize.bodyP};
                font-family: ${theme.typography.fontFamily.primary};
                line-height: ${theme.typography.lineHeight.bodyP};
            }
        }
    }

    .introjs-tooltip-header{
        padding: 0 !important;
    }

    .introjs-tooltipTitle {
        margin-bottom: ${theme.typography.fontSize.minimo};

        font-size: ${theme.typography.fontSize.bodyG};
        font-weight: ${theme.typography.fontWeight.bold};
    }

    .introjs-nextbutton {
        width: auto;
        height: auto;
        padding: 0.5rem 1rem !important;

        border-radius: 10rem !important;
        background-color: #F3F3F5 !important;

        text-align: center !important;
        text-transform: uppercase !important;

        color: ${theme.colors.gray.Cinza_2} !important;
        font-weight: ${theme.typography.fontWeight.extraBold} !important;
        font-family: ${theme.typography.fontFamily.primary} !important;
        font-size:${theme.typography.fontSize.minimo} !important;
        letter-spacing: ${theme.typography.letterSpacing.normal} !important;
        line-height: ${theme.typography.lineHeight.minimo} !important;

        :focus{
            box-shadow: none !important;
        }

    }

    .introjs-disabled{
        display: none !important;
    }

    .introjs-prevbutton {
        border: none !important;
        background-color: transparent !important;

        text-align: center !important;
        text-transform: uppercase !important;

        color: ${theme.colors.white.Branco} !important;
        font-weight: ${theme.typography.fontWeight.extraBold} !important;
        text-shadow: none !important;
        font-size: ${theme.typography.fontSize.minimo} !important;
        font-family: ${theme.typography.fontFamily.primary} !important;
        letter-spacing: ${theme.typography.letterSpacing.normal} !important;
        line-height: ${theme.typography.lineHeight.minimo} !important;

        :focus{
            box-shadow: none !important;
        }
    }

    .introjs-skipbutton {
        width: 1rem !important;
        height: 1rem !important;

        cursor: pointer;
        color: ${theme.colors.white.Branco} !important;
        font-weight: ${theme.typography.fontWeight.regular} !important;
    }

    .introjs-donebutton{
        border: none !important;
        background-color: ${theme.colors.green.Verde_AgroReceita} !important;

        color: ${theme.colors.white.Branco} !important;
        text-shadow: none !important;

        font-weight: ${theme.typography.fontWeight.extraBold};
        text-align: center;
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.minimo};
        letter-spacing: ${theme.typography.letterSpacing.normal};
        line-height: ${theme.typography.lineHeight.minimo};
    }

    .introjs-tooltipbuttons{
        padding: 0 !important;

        
        display: flex !important;
        justify-content: flex-end !important;
        
        border: none !important;
    }

    .introjs-arrow.top {
        border-bottom-color: ${theme.colors.gray.Cinza_2} !important;
    }

    .introjs-arrow.bottom {
        border-top-color: ${theme.colors.gray.Cinza_2} !important;
    }

    .introjs-helperLayer{
        border-radius: 1rem !important;
        box-shadow: rgba(33, 33, 33, 0.5) 0px 0px 0px 312.5rem !important; 
    }

    .introjs-helperNumberLayer {
        left: 1rem !important;
        bottom: 1.5rem !important;
        position: absolute !important;
        
        padding: 0 !important;

        background-color: transparent;
    }

    .introjs-overlay {
        background-color: rgba(0, 0, 0, 0.7);
    }

    .custom-tooltip-header {
        color: red;
        background-color: #ff5722;
    }

    .custom-tooltip-cardNotification {
        top: 9.75rem !important;
        left: 2.1875rem !important;

        .introjs-arrow{
            left: 1.25rem !important;
            top: -1.125rem !important;

            border: ${theme.typography.fontSize.minimo} solid transparent;
        }
    }

    .custom-tooltip-calendary {
        width: 100% !important;
        max-width: 20.5rem !important;

        @media (max-width: 479px) {
            width: 100% !important;
            padding: 1rem !important;
            max-width: 93% !important;

            margin-left: 10px;
        }

        .introjs-arrow{
            left: 1.25rem !important;
            bottom: -1.1875rem !important;

            border: ${theme.typography.fontSize.minimo} solid transparent;
        }

        .introjs-arrow.top{
            bottom: auto !important;
            top: -1.125rem !important;
        }

        .introjs-arrow.bottom-middle{
            margin-left: ${theme.typography.fontSize.minimo} !important;

            border-top-color: ${theme.colors.gray.Cinza_2} !important;
        }

        .introjs-arrow.top-middle{
            bottom: auto !important;
            top: -1.1875rem !important;

            margin-left: ${theme.typography.fontSize.minimo} !important;

            border-bottom-color: ${theme.colors.gray.Cinza_2} !important;
        }
    }

    .custom-tooltip-circleData {
        width: 100% !important;
        max-width: 20.5rem !important;

        @media (max-width: 479px) {
            width: 100% !important;
            padding: 1rem !important;
            max-width: 93% !important;

            margin-left: 10px;
        }

        .introjs-arrow{
            left: 1.25rem !important;
            bottom: -1.1875rem !important;

            border: ${theme.typography.fontSize.minimo} solid transparent;
        }

        .introjs-arrow.top{
            bottom: auto !important;
            top: -1.125rem !important;
        }

        .introjs-arrow.bottom-middle{
            margin-left: ${theme.typography.fontSize.minimo} !important;

            border-top-color: ${theme.colors.gray.Cinza_2} !important;
        }

        .introjs-arrow.top-middle{
            bottom: auto !important;
            top: -1.1875rem !important;

            margin-left: ${theme.typography.fontSize.minimo} !important;

            border-bottom-color: ${theme.colors.gray.Cinza_2} !important;
        }
    }

    .custom-tooltip-cropManagement {
        width: 100% !important;
        max-width: 20.5rem !important;

        @media (max-width: 479px) {
            width: 100% !important;
            padding: 1rem !important;
            max-width: 93% !important;

            margin-left: 10px;
        }

        .introjs-arrow{
            left: 1.25rem !important;
            bottom: -1.1875rem !important;

            border: ${theme.typography.fontSize.minimo} solid transparent;
        }

        .introjs-arrow.top{
            bottom: auto !important;
            top: -1.125rem !important;
        }

        .introjs-arrow.bottom-middle{
            margin-left: ${theme.typography.fontSize.minimo} !important;

            border-top-color: ${theme.colors.gray.Cinza_2} !important;
        }

        .introjs-arrow.top-middle{
            bottom: auto !important;
            top: -1.1875rem !important;

            margin-left: ${theme.typography.fontSize.minimo} !important;

            border-bottom-color: ${theme.colors.gray.Cinza_2} !important;
        }
    }

    .custom-tooltip-treatedArea {
        width: 100% !important;
        max-width: 20.5rem !important;

        @media (max-width: 479px) {
            width: 100% !important;
            padding: 1rem !important;
            max-width: 93% !important;

            margin-left: 10px;
        }

        .introjs-arrow{
            left: 1.25rem !important;
            bottom: -1.1875rem !important;
            
            border: ${theme.typography.fontSize.minimo} solid transparent;
        }

        .introjs-arrow.top-middle{
            bottom: auto !important;
            top: -1.1875rem !important;
            border-bottom-color: ${theme.colors.gray.Cinza_2} !important;
        }

        .introjs-arrow.bottom-middle{
            border-top-color: ${theme.colors.gray.Cinza_2} !important;
        }

        .introjs-arrow.top{
            bottom: auto !important;
            top: -1.125rem !important;
        }
    }
`;

export const Container = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
`;

export const Wrapper = styled.div` 
    width: 100%;
    height: auto;

    gap: 1.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    background-color: #FFFF;

    >div{
        width: 100%;
    }

    @media (max-width: 760px) {
        gap: 1rem;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;

    align-items: center;
`;

export const ContainerSections = styled.div`
    padding: 0 2rem 1rem;
    
    gap: 1.5rem;
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    flex-direction: column;

    @media (max-width: 760px) {
        padding: 0 1rem 1rem;
        
        gap: 1rem;
    }
`;

export const SectionOne = styled.div`
    width: 100%;
    max-width: 64.875rem;
    
    gap: 1.5rem;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    @media (max-width: 1000px) {
        gap: 1rem;
    }

    @media (max-width: 900px) {
        flex-direction: column;
    }
`;

export const SectionTwo = styled(SectionOne)``;

export const SectionThree = styled(SectionOne)``;

export const ContainerRTNotification = styled.div`
    width: auto;
    height: auto;
    padding: 0 5rem;

    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;